import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export default function DHProgress({size}) {
    return <CircularProgress size={200}/>
}